import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import avatar from '../../common/helpers/avatar';
import CustomSelect from '../../common/components/CustomSelect';
import AllConfirmModal from '../../common/dianliang/AllConfirmModal';
import LogInModal from '../components/LogInModal';
import AlertUtil from './alertUtil';

export default class PuzzleRoleBindingModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.checked = 0;
    if (vnode.attrs.getChargeList) {
      this.getChargeList = () => {
        vnode.attrs.getChargeList();
      };
    }
    this.selectVal = '';
    this.selectOption = {};
    this.roleList = {};
    this.roleVal = {};
    if (app.session.user) {
      app
        .request({
          method: 'GET',
          url: app.forum.attribute('apiUrl') + '/sdkUserRole/' + app.session.user?.id(),
        })
        .then((res) => {
          app.data['roleInfo'] = res;

          let length = 0;
          Object.keys(app.data['roleInfo']).forEach((element) => {
            if (app.data['roleInfo'][element].length > length) {
              length = app.data['roleInfo'][element].length;
            }
          });

          if (length == 0) {
            app.modal.show(AllConfirmModal, {
              title: app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.warn'),
              text: app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.user_not_role'),
              promise: true,
              onconfirm: (resolve, reject) => {
                this.hide();
                app.session.logout();
                //跳转登录页面
                app.modal.show(LogInModal);
                  // this.loading = false;
                },
              },
              true
            );
            return;
          }

          Object.keys(app.data['roleInfo']).forEach((element) => {
            app.data['roleInfo'][element].forEach((item) => {
              this.selectOption[item.rid + '_' + item.pkgId] =
                app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.srvId') +
                `:${item.srvId} ${item.name} ${item.lev}` +
                app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.level');
              this.roleList[item.rid + '_' + item.pkgId] = item;
              // if (item.current) {
              //   console.log('item->', item);

              //   app.data['GuessGameRole'] = item;
              //   this.selectVal = item.rid.toString();
              // }
            });
          });
          m.redraw.sync();
        });
    }
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small puzzle-role-modal';
  }

  title() {
    return app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.select_role');
  }

  content() {
    return (
      <div className="puzzle-role-modal-box">
        {/* <div className="puzzle-role-header">{app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.select_role')}</div> */}
        {/* <div className="puzzle-role-header">选择角色</div> */}
        <div className="puzzle-role-select">
          {Object.keys(this.selectOption).length > 0 ? (
            <CustomSelect
              value={this.selectVal}
              tip={app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.select_role')}
              options={this.selectOption}
              onchange={(e) => this.selectChange(e)}
            />
          ) : (
            <div className="Select-loading">{app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.loading')}</div>
          )}
        </div>
        <div className="puzzle-role-tip">{app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.send_reward_to_email')}</div>
        <Button className="Button" onclick={() => this.onClickSure()}>
          {app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.sure')}
        </Button>
      </div>
    );
  }
  selectChange(e) {
    this.selectVal = e;
    this.roleVal = this.roleList[e];
  }
  onClickSure() {
    const selectedRid = this.selectVal;
    if (!selectedRid) {
      return alert(app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.please_select_role'));
    }
    if (confirm(app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.select_is_not_change'))) {
      let selectedRole = null;
      Object.keys(app.data.roleInfo).forEach((pkgId) => {
        app.data.roleInfo[pkgId].find((role) => {
          if (role.rid + '_' + role.pkgId === selectedRid) {
            selectedRole = role;
            return true; // 终止查找
          }
        });
      });
      if (selectedRole) {
        app
          .request({
            method: 'POST',
            url: app.forum.attribute('apiUrl') + '/guessGame',
            body: {
              userId: app.session.user?.uniqueID(),
              pkgId: selectedRole?.pkgId,
              rid: selectedRole?.rid,
              roleName: selectedRole?.name,
              srvId: selectedRole?.srvId,
              roleLevel: selectedRole?.lev
            },
          })
          .then((apiData) => {
            if (apiData && apiData.data) {
              app.data['GuessGameRole'] = apiData.data;
              AlertUtil.onSuccess(app, app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.success_bind'));
              m.redraw.sync();
            } else {
              AlertUtil.onSuccess(app, app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.bind_error'));
            }
          })
          .catch((err) => {
            console.error(err);
          });
        this.hide();
      } else {
        alert(app.translator.trans('dl_setGuessGame.forum.PuzzleRoleBindingModal.fail_bind'));
      }
    }
  }
}
